var _mtac = { performanceMonitor: 1, senseQuery: 1 };
(function() {
  var mta = document.createElement('script');
  mta.src = '//pingjs.qq.com/h5/stats.js?v2.0.4';
  mta.setAttribute('name', 'MTAH5');
  mta.setAttribute('sid', '500607596');
  mta.setAttribute('cid', '500607598');
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(mta, s);
})();
